const defaultItemsPerPage = 15;

class CrudReducerService {
  constructor(crudNameSingular, crudNamePlural) {
    crudNameSingular =
      crudNameSingular.charAt(0).toUpperCase() + crudNameSingular.slice(1);
    crudNamePlural =
      crudNamePlural.charAt(0).toLowerCase() + crudNamePlural.slice(1);

    this.CRUD_NAME_SINGULAR = crudNameSingular;
    this.CRUD_NAME_PLURAL = crudNamePlural;

    this.setupInitialState();
  }

  setupInitialState = () => {
    this.INITIAL_STATE = {};
    this.INITIAL_STATE[`${this.CRUD_NAME_PLURAL}List`] = {
      items: [],
      needsFetch: true,
      error: null,
      loading: false,
      paging: {
          currentPage: 0,
          totalPages: 0,
          itemsPerPage: defaultItemsPerPage
      },
      sort: [],
      search: ""
    };

    this.INITIAL_STATE[`active${this.CRUD_NAME_SINGULAR}`] = {
      item: null,
      error: null,
      loading: false
    };

    this.INITIAL_STATE[`added${this.CRUD_NAME_SINGULAR}`] = {
      error: null,
      loading: false,
      added: false,
      id: null
    };

    this.INITIAL_STATE[`deleted${this.CRUD_NAME_SINGULAR}`] = {
      error: null,
      loading: false
    };
  };

  getReducer = (state, action) => {
    if (!state) {
      state = this.INITIAL_STATE;
    }
    return this.setupSwitchStatement(state, action);
  };

  setupSwitchStatement = (state = this.INITIAL_STATE, action) => {
    const crudNameSingularUpper = this.CRUD_NAME_SINGULAR.toUpperCase();
    const crudNamePluralUpper = this.CRUD_NAME_PLURAL.toUpperCase();
    const crudNamePluralCCase = this.CRUD_NAME_PLURAL.charAt(0).toLowerCase() + this.CRUD_NAME_PLURAL.slice(1);//this.CRUD_NAME_PLURAL.toLowerCase();
    const crudNameSingularTitle =
      this.CRUD_NAME_SINGULAR.charAt(0).toUpperCase() +
      this.CRUD_NAME_SINGULAR.slice(1);

    let error;
    let stateToModify = state;
    let updateOtherState;

    switch (action.type) {
      case `FETCH_${crudNamePluralUpper}`:
        stateToModify = { ...state };

        stateToModify[`${crudNamePluralCCase}List`] = {
          items: [],
          error: null,
          needsFetch: false,
          loading: true,
          paging: {
              currentPage: 0,
              totalPages: 0,
              itemsPerPage: defaultItemsPerPage
          },
          sort: [],
          search: ""
        };

        return stateToModify;
      case `FETCH_${crudNamePluralUpper}_SUCCESS`:
        stateToModify = { ...state };

        stateToModify[`${crudNamePluralCCase}List`] = {
          items: action.payload.items ? action.payload.items : action.payload,
          error: null,
          needsFetch: false,
          loading: false,
          paging: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              itemsPerPage: action.payload.itemsPerPage
          },
          sort: action.payload.sort,
          search: ""
        };

        return stateToModify;
      case `FETCH_${crudNamePluralUpper}_FAILURE`:
        error = action.payload || { message: action.payload.message };

        stateToModify = { ...state };

        stateToModify[`${crudNamePluralCCase}List`] = {
          items: [],
          needsFetch: true,
          error: error,
          loading: false,
          paging: {
              currentPage: 0,
              totalPages: 0,
              itemsPerPage: defaultItemsPerPage
          },
          sort: [],
          search: ""
        };

        return stateToModify;
      case `FETCH_${crudNameSingularUpper}`:
        stateToModify = { ...state };

        stateToModify[`active${crudNameSingularTitle}`] = {
          item: null,
          error: null,
          loading: true
        };

        return stateToModify;
      case `FETCH_${crudNameSingularUpper}_SUCCESS`:
        stateToModify = { ...state };

        stateToModify[`active${crudNameSingularTitle}`] = {
          item: action.payload,
          error: null,
          loading: false
        };

        return stateToModify;
      case `FETCH_${crudNameSingularUpper}_FAILURE`:
        error = action.payload || { message: action.payload.message };

        stateToModify = { ...state };

        stateToModify[`active${crudNameSingularTitle}`] = {
          item: null,
          error: error,
          loading: false
        };

        return stateToModify;
      case `ADD_${crudNameSingularUpper}`:
        stateToModify = { ...state };

        stateToModify[`added${crudNameSingularTitle}`] = {
          error: null,
          loading: true,
          added: false,
          id: null
        };

        return stateToModify;
      case `ADD_${crudNameSingularUpper}_SUCCESS`:
        stateToModify = { ...state };

        stateToModify[`added${crudNameSingularTitle}`] = {
          error: null,
          loading: false,
          added: true,
          id: action.payload
        };

        updateOtherState = stateToModify[`${this.CRUD_NAME_PLURAL}List`];
        updateOtherState.needsFetch = true;
        stateToModify[`${this.CRUD_NAME_PLURAL}List`] = updateOtherState;

        return stateToModify;
      case `ADD_${crudNameSingularUpper}_FAILURE`:
        error = action.payload || { message: action.payload.message };

        stateToModify = { ...state };

        stateToModify[`added${crudNameSingularTitle}`] = {
          error: error,
          loading: false,
          added: false,
          id: null
        };

        return stateToModify;
      case `UPDATE_${crudNameSingularUpper}`:
        stateToModify = { ...state };

        stateToModify[`active${crudNameSingularTitle}`] = {
          error: null,
          loading: true,
          ...stateToModify[`active${crudNameSingularTitle}`]
        };

        return stateToModify;
      case `UPDATE_${crudNameSingularUpper}_SUCCESS`:
        stateToModify = {...state};

        updateOtherState = stateToModify[`${this.CRUD_NAME_PLURAL}List`];
        updateOtherState.needsFetch = true;
        stateToModify[`${this.CRUD_NAME_PLURAL}List`] = updateOtherState;

        return stateToModify;
      case `UPDATE_${crudNameSingularUpper}_FAILURE`:
        error = action.payload || { message: action.payload.message };
        stateToModify = { ...state };

        stateToModify[`active${crudNameSingularTitle}`] = {
          error: error,
          loading: false,
          ...stateToModify[`active${crudNameSingularTitle}`]
        };

        return stateToModify;
      case `DELETE_${crudNameSingularUpper}`:
        stateToModify = { ...state };

        stateToModify[`deleted${crudNameSingularTitle}`] = {
          error: null,
          loading: true
        };

        return stateToModify;
      case `DELETE_${crudNameSingularUpper}_SUCCESS`:
        stateToModify = { ...state };

        stateToModify[`deleted${crudNameSingularTitle}`] = {
          error: null,
          loading: false
        };

        updateOtherState = stateToModify[`${this.CRUD_NAME_PLURAL}List`];
        updateOtherState.needsFetch = true;
        stateToModify[`${this.CRUD_NAME_PLURAL}List`] = updateOtherState;

        return stateToModify;
      case `DELETE_${crudNameSingularUpper}_FAILURE`:
        error = action.payload || { message: action.payload.message };
        stateToModify = { ...state };

        stateToModify[`deleted${crudNameSingularTitle}`] = {
          error: error,
          loading: false
        };

        return stateToModify;
      default:
        return stateToModify;
    }
  };
}

export default CrudReducerService;
